import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Input,
  InputNumber,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";

const PosCollectionTransactionTableFilter = (props) => {
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const { Option } = Select;
  const validInstallments = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const [subFirmSelect, setSubFirmSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getBanks();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(
      `/PosCollectionBankInfo/AddedBanks?$select=id,name`
    ).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  };

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onSubFirmSeach = (value) => {
    if (value.length >= 2) {
      setSubFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/SubFirm?&$filter=${odata.contains("name", value)} or ${odata.contains(
          "subFirmBranchNumber",
          value
        )}`
      ).then((res) => {
        setSubFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setSubFirmSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];
      if (values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }

      if (values.firmId) {
        conditions.push(`firmId eq ${values.firmId}`);
      }

      if (values.success === 0) {
        conditions.push(`success eq false`);
      }

      if (values.success === 1) {
        conditions.push(`success eq true`);
      }

      if (values.success === 2) {
        conditions.push(`success eq null`);
      }
      if (values.success === 3) {
        conditions.push(`isCancel eq true`);
      }
      if (values.success === 4) {
        conditions.push(`isRefund eq true`);
      }
      if (values.success === 5) {
        conditions.push(`isPartialRefund eq true`);
      }
      if (values.authCode) {
        conditions.push(odata.contains("authCode", values.authCode));
      }

      if (values.cancelRefundRequest == 1) {
        conditions.push(`cancelRefundRequest eq 0 or cancelRefundRequest eq 1`);
      }

      if (values.cancelRefundRequest == 0) {
        conditions.push(`cancelRefundRequest eq null`);
      }

      if (values.addDateRange) {
        const [startDate, endDate] = values.addDateRange;

        conditions.push(odata.dateRange("addDate", startDate, endDate));
      }

      if (values.amountMin) {
        conditions.push(`amount Ge ${values.amountMin}`);
      }

      if (values.amountMax) {
        conditions.push(`amount Le ${values.amountMax}`);
      }

      if (values.holderName) {
        conditions.push(odata.contains("holderName", values.holderName));
      }
      if (values.cardNumber) {
        conditions.push(odata.contains("cardNumber", values.cardNumber));
      }

      if (values.installmentCount) {
        conditions.push(`installmentCount eq ${values.installmentCount}`);
      }

      if (values.subFirmId) {
        conditions.push(`subFirmId eq ${values.subFirmId}`);
      }

      //~ preAuth
      if (values.preAuth === 0) {
        conditions.push(`isPreAuth eq true`);
      }

      if (values.preAuth === 1) {
        conditions.push(`isPreAuth eq true and isPreAuthSuccess eq true`);
      }

      if (values.preAuth === 2) {
        conditions.push(`isPreAuth eq true and isPreAuthSuccess ne true`);
      }
      if (values.preAuth === 3) {
        conditions.push(`isPreAuth eq true and success eq true`);
      }

      //~ preAuth

      if (values.isCommissionIncluded === 0) {
        conditions.push(`isCommissionIncluded eq true`);
      }
      if (values.isCommissionIncluded === 1) {
        conditions.push(`isCommissionIncluded ne true`);
      }
      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Bayi" name="firmId">
                    <Select
                      allowClear
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "50%" }}
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSeach}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name + " ( " + item.firmBranchNumber + " ) "}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="success" label="İşlem Sonucu :">
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Başarısız" },
                        { id: 1, name: "Başarılı" },
                        { id: 2, name: "Sonuç Bekliyor" },
                        { id: 3, name: "İptal" },
                        { id: 4, name: "İade" },
                        { id: 5, name: "Kısmi İade" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="addDateRange" label="İşlem Tarihi :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="authCode" label="Onay Kodu :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="cancelRefundRequest"
                    label="İptal/İade Talebi :"
                  >
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 1, name: "Var" },
                        { id: 0, name: "Yok" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Toplam Tutar :" style={{ marginBottom: 0 }}>
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber min={0} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber min={0} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="holderName" label="Kart Sahibi Adı :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="installmentCount" label="Taksit Sayısı :">
                    <Select allowClear>
                      {validInstallments.map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="cardNumber" label="Kart Numarası :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="isCommissionIncluded" label="KTD İşlemi:">
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Evet" },
                        { id: 1, name: "Hayır" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="preAuth" label="Provizyon İşlem:">
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Provizyon İşlemi" },
                        { id: 1, name: "Başarılı Provizyon İşlemi" },
                        { id: 2, name: "Başarısız Provizyon İşlemi" },
                        {
                          id: 3,
                          name: "Başarılı Kapama Yapılmış Provizyon İşlemi",
                        },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default PosCollectionTransactionTableFilter;
